'use strict';

var _ = require('lodash');
function InterlineFaresAdjustmentCSVImportModalDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/interline-fares-adjustment-upload-modal.html'),
    controller: 'InterlineFaresAdjustmentUploadImportModalController',
    link: function link(scope, element) {
      scope.withTitle = true;
      element.find('.import-help-icon').popover();
      scope.$on('grid:showImportModal', function () {
        element.modal('show');
      });
      scope.$on('interline-fares-adjustment-upload:errorLogClose', function () {
        scope.hideErrorLog();
      });
      function resetInput(elem) {
        elem.wrap('<form>').closest('form').get(0).reset();
        elem.unwrap();
      }
      element.on('hidden.bs.modal', function () {
        resetInput(element.find('#import-browse-button'));
      });
      element.find('#import-browse-button').bind('change', function (event) {
        $timeout(function () {
          var file = _.first(event.target.files);
          var fileName = _.isUndefined(file) ? '' : file.name;
          if (_.endsWith(fileName, '.csv')) {
            scope.chosenFileName = fileName;
            scope.chosenFile = file;
          } else {
            scope.chosenFileName = '';
            scope.chosenFile = null;
          }
        }, 0);
      });
    }
  };
}
InterlineFaresAdjustmentCSVImportModalDirective.$inject = ['$timeout'];
module.exports = InterlineFaresAdjustmentCSVImportModalDirective;